function attachCustomDataToRaygun(customData) {
  if (window.rg4js) {
    window.rg4js('withCustomData', customData)
  }
}

export default attachCustomDataToRaygun
